import { ASMDisplayState } from '@rome/response/common/enums/ASMDisplayState';
import get from 'lodash/get';
import ApiCaller from './ApiCaller';
import baseAjaxConfig, { headers } from './BaseAjaxConfig';
export var asmActions;
(function (asmActions) {
    asmActions["REGISTER_FOR_SALE_REQUEST"] = "REGISTER_FOR_SALE_REQUEST";
    asmActions["REGISTER_FOR_SALE_SUCCESS"] = "REGISTER_FOR_SALE_SUCCESS";
    asmActions["REGISTER_FOR_SALE_ERROR"] = "REGISTER_FOR_SALE_ERROR";
    asmActions["JOIN_WAITLIST_REQUEST"] = "JOIN_WAITLIST_REQUEST";
    asmActions["JOIN_WAITLIST_SUCCESS"] = "JOIN_WAITLIST_SUCCESS";
    asmActions["JOIN_WAITLIST_ERROR"] = "JOIN_WAITLIST_ERROR";
    asmActions["RERESERVE_REQUEST"] = "RERESERVE_REQUEST";
    asmActions["RERESERVE_SUCCESS"] = "RERESERVE_SUCCESS";
    asmActions["RERESERVE_ERROR"] = "RERESERVE_ERROR";
    asmActions["ASM_NEXT_STATE"] = "ASM_NEXT_STATE";
    asmActions["ASM_CLEAR_POPUP"] = "ASM_CLEAR_POPUP";
    asmActions["ASM_POPULATE_DATA"] = "ASM_POPULATE_DATA";
    asmActions["ASM_PRODUCT_OOS"] = "ASM_PRODUCT_OOS";
})(asmActions || (asmActions = {}));
export function registerForSale(options) {
    return (dispatch) => {
        dispatch({
            type: asmActions.REGISTER_FOR_SALE_REQUEST
        });
        return ApiCaller.post(Object.assign({}, baseAjaxConfig, {
            headers,
            pathname: '/api/2/sale/register',
            action: asmActions.REGISTER_FOR_SALE_REQUEST
        }), {
            saleId: options.saleId
        }).then(json => dispatch({
            type: asmActions.REGISTER_FOR_SALE_SUCCESS,
            data: json.RESPONSE
        }), err => {
            dispatch({
                type: asmActions.REGISTER_FOR_SALE_ERROR,
                error: err
            });
            return Promise.reject(err);
        });
    };
}
export function joinWaitList(options) {
    return (dispatch) => {
        dispatch({
            type: asmActions.JOIN_WAITLIST_REQUEST
        });
        return ApiCaller.post(Object.assign({}, baseAjaxConfig, {
            headers,
            pathname: '/api/5/cart/waitlist',
            action: asmActions.JOIN_WAITLIST_REQUEST
        }), {
            cartContext: {
                [options.listingId]: {
                    quantity: 1
                }
            }
        }).then(json => {
            const response = get(json, ['RESPONSE']);
            const asmDisplayState = get(response, [
                'asmData',
                'renderableComponents',
                0,
                'value',
                'callout',
                'displayState'
            ]);
            if (asmDisplayState === ASMDisplayState.OOS) {
                dispatch(asmProductOOS(get(response, ['asmData', 'renderableComponents', 0])));
            }
            return dispatch({
                type: asmActions.JOIN_WAITLIST_SUCCESS,
                data: json.RESPONSE
            });
        }, err => {
            dispatch({
                type: asmActions.JOIN_WAITLIST_ERROR,
                error: err
            });
            return Promise.reject(err);
        });
    };
}
export function reReserveProduct(options) {
    return (dispatch) => {
        dispatch({
            type: asmActions.RERESERVE_REQUEST
        });
        return ApiCaller.post(Object.assign({}, baseAjaxConfig, {
            headers,
            pathname: '/api/5/cart/reserve',
            action: asmActions.RERESERVE_REQUEST,
            acceptErrors: true
        }), {
            cartContext: {
                [options.listingId]: {
                    quantity: 1
                }
            }
        }).then(json => dispatch({
            type: asmActions.RERESERVE_SUCCESS,
            data: json.RESPONSE
        }), err => {
            dispatch({
                type: asmActions.RERESERVE_ERROR,
                error: err
            });
            return Promise.reject(err);
        });
    };
}
export function asmNextState() {
    return {
        type: asmActions.ASM_NEXT_STATE
    };
}
export function asmClearPopup() {
    return {
        type: asmActions.ASM_CLEAR_POPUP
    };
}
export function asmProductOOS(data) {
    return {
        type: asmActions.ASM_PRODUCT_OOS,
        data
    };
}
